/**
 * pdfUtils.js
 * Generates and downloads a professional PDF CV.
 *
 * Requires: npm install @react-pdf/renderer
 * Remove:   npm uninstall html2pdf.js
 */

import React from 'react';
import { pdf } from '@react-pdf/renderer';
import CVDocument from './CVDocument';

/**
 * Generates the CV as a PDF Blob and triggers a browser download.
 *
 * @param  {Object}   profile  — the profile object from profileData.js
 * @returns {Promise<void>}    — resolves when download is triggered
 * @throws  {Error}            — rethrows so callers can display feedback
 */
export const downloadProfileAsPDF = async (profile) => {
    if (!profile) throw new Error('No profile data provided');

    const filename = `${profile.name.replace(/\s+/g, '_')}_CV.pdf`;

    // Render to Blob — this is where @react-pdf does its work
    const blob = await pdf(<CVDocument profile={profile} />).toBlob();

    // Trigger browser download
    const url = URL.createObjectURL(blob);
    const a   = Object.assign(document.createElement('a'), {
        href:     url,
        download: filename,
    });
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Release object URL after the download dialog has had time to open
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
};
